import { render, staticRenderFns } from "./CardSummaryOrderRetur.vue?vue&type=template&id=e45a8058&"
import script from "./CardSummaryOrderRetur.vue?vue&type=script&lang=js&"
export * from "./CardSummaryOrderRetur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports